import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, X } from 'lucide-react';
import "../css/MultiSelectDropdown.css";

const MultiSelectDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const dropdownRef = useRef(null);

  const options = [
    { id: 1, label: 'JavaScript', value: 'javascript' },
    { id: 2, label: 'React', value: 'react' },
    { id: 3, label: 'Vue.js', value: 'vue' },
    { id: 4, label: 'Angular', value: 'angular' },
    { id: 5, label: 'Node.js', value: 'nodejs' },
    { id: 6, label: 'Python', value: 'python' },
    { id: 7, label: 'TypeScript', value: 'typescript' },
    { id: 8, label: 'HTML', value: 'html' },
    { id: 9, label: 'CSS', value: 'css' },
    { id: 10, label: 'PHP', value: 'php' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleItemSelect = (item) => {
    const isSelected = selectedItems.some(selected => selected.id === item.id);
    if (isSelected) {
      setSelectedItems(selectedItems.filter(selected => selected.id !== item.id));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const removeSelectedItem = (itemToRemove) => {
    setSelectedItems(selectedItems.filter(item => item.id !== itemToRemove.id));
  };

  const clearAll = () => {
    setSelectedItems([]);
  };

  return (
    <div className="dropdown-container">
      <h2 className="dropdown-title">Multi-Select Dropdown</h2>
      
      <div className="dropdown-wrapper" ref={dropdownRef}>
        <div onClick={toggleDropdown} className="dropdown-toggle">
          <div className="dropdown-selected-items">
            {selectedItems.length === 0 ? (
              <span className="dropdown-placeholder">Select technologies...</span>
            ) : (
              selectedItems.map(item => (
                <span key={item.id} className="dropdown-tag">
                  {item.label}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      removeSelectedItem(item);
                    }}
                    className="dropdown-tag-remove"
                  >
                    <X size={12} />
                  </button>
                </span>
              ))
            )}
          </div>
          <ChevronDown 
            size={20} 
            className={`dropdown-chevron ${isOpen ? 'rotate-180' : ''}`}
          />
        </div>

        {isOpen && (
          <div className="dropdown-menu">
            {selectedItems.length > 0 && (
              <div className="dropdown-clear-container">
                <button onClick={clearAll} className="dropdown-clear-button">
                  Clear All ({selectedItems.length})
                </button>
              </div>
            )}
            <div className="dropdown-options">
              {options.map(option => {
                const isSelected = selectedItems.some(item => item.id === option.id);
                return (
                  <div
                    key={option.id}
                    onClick={() => handleItemSelect(option)}
                    className={`dropdown-option ${isSelected ? 'selected' : ''}`}
                  >
                    <span>{option.label}</span>
                    {isSelected && (
                      <div className="option-indicator">
                        <div className="option-indicator-inner" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {selectedItems.length > 0 && (
        <div className="dropdown-selected-display">
          <h3 className="dropdown-selected-title">Selected Items:</h3>
          <ul className="dropdown-selected-list">
            {selectedItems.map(item => (
              <li key={item.id} className="dropdown-selected-item">• {item.label}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
